export const FEE_CATEGORY = [
	{ key: 'TFGoF', text: 'Total Fund Gross of Fees' },
	{ key: 'TFNoF', text: 'Total Fund Net of Fees' },
	{ key: 'TFNoMF', text: 'Total Fund Net of Manager Fees' },
	{ key: 'TGfGS', text: 'Total Fund Gross from Fee Schedule' },
	{ key: 'TFNfFS', text: 'Total Fund Net from Fee Schedule' },
	{ key: 'cscfx', text: 'Cash, Synthetic Cash, + All FX' },
];
export const WORKSPACE_TYPE = [
	{ key: 'rateofreturn', text: 'Rate of Return' },
	{ key: 'attribution', text: 'Attribution' },
];
export const ANALYSIS_LEVELS = [
	{ key: 'Account', text: 'Account' },
	{ key: 'Hierarchy', text: 'Investment Hierarchy' },
	{ key: 'CustomGroup', text: 'Custom Group' },
];
export const TEMPLATES = [
	{ key: 'Category', text: 'Category' },
	{ key: 'GICS', text: 'GICS' },
	{ key: 'Custom', text: 'Custom' },
];

export const HIERARCHY_LEVELS_INCLUDE = [
	{ key: 'All Levels', text: 'AllLevels' },
	{ key: 'Accounts Only', text: 'AccountsOnly' },
	{ key: 'Custom Dimensions', text: 'CustomDimensions' },
];

export const FREQUENCY_OPTIONS = [
	{ key: 'Daily', text: 'Daily' },
	{ key: 'Monthly', text: 'Monthly' },
	{ key: 'Yearly', text: 'Yearly' },
];
